/* src/app/common/components/order-display-screen/order-display-screen.component.scss */
::ng-deep .select-icon {
  margin-left: 1rem !important;
  color: #eee !important;
}
:host {
  display: block;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  color: #222;
  font-family:
    "Inter",
    "Roboto",
    Arial,
    sans-serif;
}
.display-screen-root {
  display: flex;
  flex-direction: column;
  background: #f9fdf9;
  padding-bottom: 20px !important;
}
.display-screen-footer {
  margin-bottom: 10px;
  background: #e0e0e0;
  color: #333;
  text-align: center;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}
.display-screen-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: #59ac77;
  color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
}
.display-screen-header ion-button {
  display: flex !important;
  align-items: center;
}
.display-screen-header .back-btn {
  --background: #fff0dd;
  --color: #31326f;
  --border-radius: 6px;
  --padding: 6px 12px;
  font-weight: 600;
  font-size: 14px;
}
.display-screen-header .back-btn ion-icon {
  margin-right: 4px;
  vertical-align: middle;
}
.display-screen-header .clock {
  font-size: 16px;
  font-weight: 600;
  color: #ffcb61;
}
.display-screen-header ion-title {
  font-size: 28px;
  font-weight: 700;
  color: #fcf8dd;
  text-align: center;
  margin-left: 12rem;
  flex-grow: 1;
}
.branch-selector {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 1rem;
  margin-right: 1rem;
  width: 200px;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.branch-selector .branch-label {
  font-size: 14px;
  font-weight: 600;
  margin-left: 0.5rem;
  color: #555;
}
.branch-selector .branch-dropdown {
  --background: transparent !important;
  --border-color: #ccc;
  --border-width: 1px;
  --border-style: solid;
  outline: none !important;
  border-radius: 6px;
  width: 100%;
}
.order-card {
  width: 100%;
  padding: 18px 24px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #dcefdc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.order-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.order-card .card-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 1rem;
}
.order-card .card-left {
  flex: 1;
  min-width: 160px;
}
.order-card .card-left .order-number {
  font-size: 24px;
  font-weight: 700;
  color: #1055c9;
  margin-bottom: 6px;
}
.order-card .card-left .restaurant {
  font-size: 16px;
  font-weight: 600;
  color: #132440;
}
.order-card .card-middle {
  flex: 1;
  text-align: center;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.order-card .card-middle .status-badge {
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 6px;
  text-transform: uppercase;
  background: #e3f2fd;
  margin-bottom: 6px;
}
.order-card .card-middle .status-badge.status-active {
  background: #e3f2fd;
  color: #0089ff;
}
.order-card .card-middle .status-badge.status-delivered {
  background: #e8f5e9;
  color: #41a67e;
}
.order-card .card-middle .status-badge.status-cancelled {
  background: #ffebee;
  color: #e43636;
}
.order-card .card-middle .status-badge.status-unknown {
  background: #f5f5f5;
  color: #757575;
}
.order-card .card-right {
  min-width: 180px;
  text-align: right;
}
.order-card .card-right .amount {
  font-size: 18px;
  font-weight: 700;
  color: #05339c;
  margin-bottom: 10px;
}
.order-card .card-right .progress-bar {
  width: 100%;
  height: 5px;
  border-radius: 3px;
  background: #e0e0e0;
  overflow: hidden;
}
.order-card .card-right .progress-bar .progress {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease, background 0.3s ease;
}
.order-card .card-right .progress-bar.progress-green .progress {
  background: #41a67e;
}
.order-card .card-right .progress-bar.progress-blue .progress {
  background: #0099ff;
}
.order-card .card-right .progress-bar.progress-red .progress {
  background: #e43636;
}
.status-meta {
  font-size: 15px;
  color: #132440;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.status-meta .dot {
  font-size: 20px;
  color: #b6ae9f;
}
/*# sourceMappingURL=order-display-screen.component.css.map */
